"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.totpSchema = exports.registerLiteSchema = exports.changeEmailSchema = exports.forgotPasswordSchema = exports.changePasswordSchemaServerside = exports.changePasswordSchema = exports.validResidencySchema = exports.residencyPostcodeValidation = exports.residencyPlaceValidation = exports.residencyStreetAddressValidation = exports.validServersideLoginSchema = exports.validServersideStrippedRegisterSchema = exports.validLoginSchema = exports.validXtagSchema = exports.validUserDetailsSchema = exports.validStrippedUserSchema = exports.validUserSchema = exports.acceptTermsValidation = exports.xtagValidation = exports.totpValidation = exports.loginPasswordValidationServerside = exports.loginPasswordValidation = exports.registerDetailsDOBValidation = exports.registerDOBValidation = exports.registerTermsValidation = exports.registerEmailValidation = exports.registerPasswordValidationServerside = exports.registerPasswordValidation = exports.mustAcceptTerms = exports.passwordWeak = exports.passwordMissingSpecial = exports.passwordMissingNumber = exports.passwordMissingUppercase = exports.passwordMissingLowercase = exports.alphabetOnly = exports.invalidResidence = exports.termsNotChecked = exports.unauthorisedDOB = exports.invalidDOB = exports.alreadyActivatedMFA = exports.incorrectOTP = exports.invalidOTP = exports.invalidLogin = exports.requiredField = exports.invalidEmail = exports.passwordMismatch = exports.passwordNotLongEnough = exports.emailNotLongEnough = void 0;
const yup = __importStar(require("yup"));
const moment_1 = __importDefault(require("moment"));
// frontend validation
// NOTE: Always add backend validation too - frontend validation is useful as it saves server resources and is quicker
exports.emailNotLongEnough = "Email must be at least 3 characters";
exports.passwordNotLongEnough = "Password must be at least 10 characters";
exports.passwordMismatch = "Passwords do not match";
exports.invalidEmail = "Invalid Email";
exports.requiredField = "Required";
exports.invalidLogin = "Invalid Login";
exports.invalidOTP = "Invalid OTP";
exports.incorrectOTP = "Incorrect OTP";
exports.alreadyActivatedMFA = "ERROR: 2FA is already active";
exports.invalidDOB = "Invalid format (YYYY.MM.DD)";
exports.unauthorisedDOB = "18+ years old only";
exports.termsNotChecked = "You must agree to the terms";
exports.invalidResidence = "Invalid Residence";
exports.alphabetOnly = "Alphabetical characters only";
exports.passwordMissingLowercase = "Password must contain at least one lowercase character";
exports.passwordMissingUppercase = "Password must contain at least one uppercase character";
exports.passwordMissingNumber = "Password must contain at least one number";
exports.passwordMissingSpecial = "Password must contain at least one special character (!.@#$%^&*(){};:',~€£=-)";
exports.passwordWeak = "Your password is weak. Press 'forgot password' to upgrade to a stronger password.";
exports.mustAcceptTerms = "You must accept the Ts & Cs to proceed.";
exports.registerPasswordValidation = yup
    .string()
    .min(3, exports.passwordNotLongEnough)
    .max(255)
    .required(exports.requiredField);
exports.registerPasswordValidationServerside = yup
    .string()
    .min(10, exports.passwordNotLongEnough)
    .matches(/^.*[a-z].*/, exports.passwordMissingLowercase)
    .matches(/^.*[A-Z].*/, exports.passwordMissingUppercase)
    .matches(/^.*[0-9].*/, exports.passwordMissingNumber)
    .matches(/^.*[!.@#$%^&*(){};:',~€£=-].*/, exports.passwordMissingSpecial)
    .max(255)
    .required(exports.requiredField);
exports.registerEmailValidation = yup
    .string()
    .min(3, exports.emailNotLongEnough)
    .max(255)
    .email(exports.invalidEmail)
    .required(exports.requiredField);
exports.registerTermsValidation = yup
    .bool()
    .oneOf([true], exports.termsNotChecked);
exports.registerDOBValidation = yup
    .string()
    .matches(/^\d{4}-([0]\d|1[0-2])-([0-2]\d|3[01])$/, exports.invalidDOB)
    .test("dob", exports.unauthorisedDOB, (value) => {
    return (0, moment_1.default)().diff((0, moment_1.default)(value), "years") >= 18;
})
    .required(exports.requiredField);
exports.registerDetailsDOBValidation = yup
    .string()
    .test("dob", exports.unauthorisedDOB, (value) => {
    return (0, moment_1.default)().diff((0, moment_1.default)(value), "years") >= 18;
})
    .required(exports.requiredField);
exports.loginPasswordValidation = yup
    .string()
    .max(255, exports.invalidLogin)
    .required(exports.requiredField)
    .min(3, exports.invalidLogin);
exports.loginPasswordValidationServerside = yup
    .string()
    .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!.@#$%^&*(){};:',~€£=-])(?=.{8,})/, exports.passwordWeak)
    .max(255)
    .required(exports.requiredField);
exports.totpValidation = yup
    .string()
    .max(6, exports.invalidOTP)
    .min(6, exports.invalidOTP)
    .matches(/^[0-9]+$/, exports.invalidOTP)
    .required(exports.requiredField);
exports.xtagValidation = yup
    .string()
    .min(2)
    .max(10)
    .matches(/^[aA-zZ\s]+$/, exports.alphabetOnly)
    .required(exports.requiredField);
exports.acceptTermsValidation = yup
    .bool()
    .oneOf([true], exports.mustAcceptTerms)
    .required(exports.mustAcceptTerms);
exports.validUserSchema = yup.object().shape({
    forename: yup.string().max(255).required(exports.requiredField),
    surname: yup.string().max(255).required(exports.requiredField),
    email: exports.registerEmailValidation,
    password: exports.registerPasswordValidationServerside,
    dob: exports.registerPasswordValidationServerside,
});
exports.validStrippedUserSchema = yup.object().shape({
    email: exports.registerEmailValidation,
    password: exports.registerPasswordValidationServerside,
    acceptTerms: exports.acceptTermsValidation,
});
exports.validUserDetailsSchema = yup.object().shape({
    forename: yup.string().max(255).required(exports.requiredField),
    surname: yup.string().max(255).required(exports.requiredField),
    dob: exports.registerDetailsDOBValidation,
});
exports.validXtagSchema = yup.object().shape({
    xtag: exports.xtagValidation,
    acceptTerms: exports.acceptTermsValidation,
});
exports.validLoginSchema = yup.object().shape({
    email: yup
        .string()
        .max(255, exports.invalidLogin)
        .email(exports.invalidLogin)
        .required(exports.requiredField),
    password: exports.loginPasswordValidation,
});
exports.validServersideStrippedRegisterSchema = yup.object().shape({
    email: yup
        .string()
        .max(255, exports.invalidLogin)
        .email(exports.invalidLogin)
        .required(exports.requiredField),
    password: exports.registerPasswordValidationServerside,
});
exports.validServersideLoginSchema = yup.object().shape({
    email: yup
        .string()
        .max(255, exports.invalidLogin)
        .email(exports.invalidLogin)
        .required(exports.requiredField),
    password: exports.loginPasswordValidationServerside,
});
exports.residencyStreetAddressValidation = yup
    .string()
    .max(100, exports.invalidResidence)
    .required(exports.requiredField)
    .min(5, exports.invalidResidence);
exports.residencyPlaceValidation = yup
    .string()
    .max(50, exports.invalidResidence)
    .required(exports.requiredField)
    .min(2, exports.invalidResidence);
exports.residencyPostcodeValidation = yup
    .string()
    .max(20, exports.invalidResidence)
    .required(exports.requiredField)
    .min(2, exports.invalidResidence);
exports.validResidencySchema = yup.object().shape({
    streetAddress: exports.residencyStreetAddressValidation,
    city: exports.residencyPlaceValidation,
    region: exports.residencyPlaceValidation,
    postcode: exports.residencyPostcodeValidation,
    country: exports.residencyPlaceValidation,
    nationality: exports.residencyPlaceValidation,
});
// export const changePasswordSchema = yup.object().shape({
//   newPassword: registerPasswordValidation,
//   confirmNewPassword: yup.mixed().test("match", passwordMismatch, function () {
//     return this.parent.newPassword === this.parent.confirmNewPassword;
//   }),
// });
exports.changePasswordSchema = yup.object({
    newPassword: exports.loginPasswordValidation,
    confirmNewPassword: yup
        .string()
        .oneOf([yup.ref("newPassword"), null], "Passwords must match")
        .required("Password confirmation is required"),
});
exports.changePasswordSchemaServerside = yup.object({
    newPassword: exports.registerPasswordValidationServerside,
});
exports.forgotPasswordSchema = yup.object().shape({
    email: exports.registerEmailValidation,
});
exports.changeEmailSchema = yup.object().shape({
    email: exports.registerEmailValidation,
});
exports.registerLiteSchema = yup.object().shape({
    email: exports.registerEmailValidation,
});
exports.totpSchema = yup.object().shape({
    totp: exports.totpValidation,
});
//# sourceMappingURL=user.js.map